(() => {
  const CONVERSION = 2.54;

  const convertTextToInches = (value) => {
    if (!value) return value;

    return value.replace(/-?\d+(?:[.,]\d+)?/g, (match) => {
      const normalized = Number(match.replace(',', '.'));

      if (!Number.isFinite(normalized)) return match;

      const inches = normalized / CONVERSION;
      const rounded = Math.round(inches * 10) / 10;

      return Number.isInteger(rounded)
        ? String(rounded)
        : rounded.toFixed(1);
    });
  };

  const setUnit = (dialog, unit) => {
    if (!dialog) return;

    dialog.dataset.currentUnit = unit;

    dialog.querySelectorAll('[data-minaco-size-unit]').forEach((button) => {
      const active = button.dataset.minacoSizeUnit === unit;

      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });

    dialog.querySelectorAll('[data-minaco-size-value]').forEach((cell) => {
      const cm = cell.dataset.cm || '';

      cell.textContent = unit === 'in'
        ? convertTextToInches(cm)
        : cm;
    });
  };

  const resetAccordion = (dialog) => {
    const items = Array.from(
      dialog.querySelectorAll('[data-minaco-size-accordion-item]')
    );

    items.forEach((item, index) => {
      const trigger = item.querySelector('[data-minaco-size-accordion-trigger]');
      const panel = item.querySelector('[data-minaco-size-accordion-panel]');
      const open = index === 0;

      item.classList.toggle('is-open', open);

      if (trigger) {
        trigger.setAttribute(
          'aria-expanded',
          open ? 'true' : 'false'
        );
      }

      if (panel) {
        panel.hidden = !open;
      }
    });
  };

  const openDialog = (dialog, opener) => {
    if (!dialog) return;

    dialog._minacoOpener = opener || null;

    setUnit(dialog, 'cm');
    resetAccordion(dialog);

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }

    document.body.classList.add('minaco-size-chart-open');

    requestAnimationFrame(() => {
      dialog
        .querySelector('[data-minaco-size-chart-close]')
        ?.focus({ preventScroll: true });
    });
  };

  const closeDialog = (dialog) => {
    if (!dialog) return;

    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }

    document.body.classList.remove('minaco-size-chart-open');

    dialog._minacoOpener?.focus?.({
      preventScroll: true
    });
  };

  const openAccordionItem = (item) => {
    const accordion = item.closest('[data-minaco-size-accordion]');

    if (!accordion) return;

    const items = Array.from(
      accordion.querySelectorAll('[data-minaco-size-accordion-item]')
    );

    items.forEach((otherItem) => {
      const trigger = otherItem.querySelector('[data-minaco-size-accordion-trigger]');
      const panel = otherItem.querySelector('[data-minaco-size-accordion-panel]');
      const active = otherItem === item;

      otherItem.classList.toggle('is-open', active);

      if (trigger) {
        trigger.setAttribute(
          'aria-expanded',
          active ? 'true' : 'false'
        );
      }

      if (panel) {
        panel.hidden = !active;
      }
    });
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-minaco-size-chart-open]');

    if (opener) {
      const id = opener.getAttribute('data-minaco-size-chart-open');

      openDialog(
        document.getElementById(id),
        opener
      );

      return;
    }

    const close = event.target.closest('[data-minaco-size-chart-close]');

    if (close) {
      closeDialog(
        close.closest('[data-minaco-size-chart-dialog]')
      );

      return;
    }

    const unit = event.target.closest('[data-minaco-size-unit]');

    if (unit) {
      const dialog = unit.closest('[data-minaco-size-chart-dialog]');

      setUnit(
        dialog,
        unit.dataset.minacoSizeUnit
      );

      return;
    }

    const accordionTrigger = event.target.closest(
      '[data-minaco-size-accordion-trigger]'
    );

    if (accordionTrigger) {
      const item = accordionTrigger.closest(
        '[data-minaco-size-accordion-item]'
      );

      if (!item) return;

      /*
        One accordion is always open.
        If the user clicks the currently-open one,
        we leave it open.
      */
      if (item.classList.contains('is-open')) {
        return;
      }

      openAccordionItem(item);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const dialog = document.querySelector(
      '[data-minaco-size-chart-dialog][open]'
    );

    if (dialog) {
      closeDialog(dialog);
    }
  });

  document
    .querySelectorAll('[data-minaco-size-chart-dialog]')
    .forEach((dialog) => {
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;

        const surface = dialog.querySelector(
          '[data-minaco-size-chart-surface]'
        );

        const rect = surface?.getBoundingClientRect();

        if (!rect) return;

        const outside =
          event.clientX < rect.left ||
          event.clientX > rect.right ||
          event.clientY < rect.top ||
          event.clientY > rect.bottom;

        if (outside) {
          closeDialog(dialog);
        }
      });

      dialog.addEventListener('close', () => {
        document.body.classList.remove(
          'minaco-size-chart-open'
        );
      });
    });
})();
